import React from 'react';
import { Modal, Form, Input, Select, Row, Col, Button, message } from 'antd';
import axios from 'axios';

const { Option } = Select;

class UserInfoModalClass extends React.Component {
    // 处理表单提交
    handleSubmit = () => {
        const { form, onFinish, onCancel } = this.props;
        form.validateFields((err, values) => {
            if (!err) {
                // 构造提交数据
                const submitData = {
                    name: values.name,
                    phone: values.phone,
                    position: values.position,
                    email: values.email || '',
                    company: values.companyName,
                    companyType: values.companyType,
                    industry: values.industry,
                    products: values.products
                };

                // 发送POST请求
                axios.post('https://aiwebsitemail.aicalming.com:7001/submit-form-v', submitData)
                    .then(response => {
                        message.success('提交成功');
                        form.resetFields();
                        onCancel(); // 提交成功后关闭弹窗
                    })
                    .catch(error => {
                        message.error('提交失败：' + (error.response && error.response.data && error.response.data.message || error.message));
                        console.error('Submit Failed:', error);
                    });
            } else {
                console.log('Validate Failed:', err);
            }
        });
    };

    // 手机号验证规则
    validatePhone = (rule, value, callback) => {
        const phoneRegex = /^1[3-9]\d{9}$/;
        if (!value) {
            callback('请输入联系人电话');
        } else if (!phoneRegex.test(value)) {
            callback('请输入有效的11位手机号');
        } else {
            callback();
        }
    };

    render() {
        const { visible, onCancel, form } = this.props;
        const { getFieldDecorator } = form;

        // 公司类别选项
        const companyTypes = [
            '终端用户',
            '硬件制造商',
            '集成商',
            '渠道代理商',
            '其他'
        ];

        // 行业所属选项
        const industries = [
            '制造业', '医疗健康', '金融', '教育', '零售',
            '物流', '互联网', '能源', '建筑', '其他'
        ];

        // 关注产品选项
        const products = [
            '医疗供应链 - UDI码追溯',
            '医疗供应链 - 骨科内固定器械清点',
            '医疗供应链 - 手术工具清点',
            '数据治理 - 器械主数据对码',
            '数据治理 - 首营资料智能管理',
            '数据治理 - AI标书自动写作平台',
            '数据治理 - 企业智能问答系统',
            '工业质检 - 口红质检',
            '工业质检 - 瓶底喷码质检',
            '新能源 - 太阳能板质检'
        ];

        return (
            <Modal
                title="用户信息"
                visible={visible}
                onCancel={onCancel}
                width={720} // 增加弹窗宽度
                footer={[
                    <Button key="cancel" onClick={onCancel}>
                        取消
                    </Button>,
                    <Button key="submit" type="primary" style={{ background: '#112a87',borderColor:'#112a87' }} onClick={this.handleSubmit}>
                        提交
                    </Button>,
                ]}
                className="custom-modal"
                bodyStyle={{ padding: '24px' }}
            >
                <Form layout="vertical">
                    {/* 第一行：每行3个输入框 */}
                    <Row gutter={16}>
                        <Col span={8}>
                            <Form.Item label="联系人姓名">
                                {getFieldDecorator('name', {
                                    rules: [{ required: true, message: '请输入联系人姓名' }],
                                })(
                                    <Input placeholder="请输入姓名" />
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label="联系人电话">
                                {getFieldDecorator('phone', {
                                    rules: [
                                        { required: true, message: '请输入联系人电话' },
                                        { validator: this.validatePhone }
                                    ],
                                })(
                                    <Input placeholder="请输入手机号" maxLength={11} />
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label="联系人岗位">
                                {getFieldDecorator('position', {
                                    rules: [{ required: true, message: '请输入联系人岗位' }],
                                })(
                                    <Input placeholder="请输入岗位" />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>

                    {/* 第二行：邮箱 + 公司名称 */}
                    <Row gutter={16}>
                        <Col span={8}>
                            <Form.Item label="联系人邮箱">
                                {getFieldDecorator('email')(
                                    <Input placeholder="请输入邮箱" />
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={16}>
                            <Form.Item label="公司名称">
                                {getFieldDecorator('companyName', {
                                    rules: [{ required: true, message: '请输入公司名称' }],
                                })(
                                    <Input placeholder="请输入公司名称" />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>

                    {/* 第三行：每行2个下拉选择 */}
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item label="公司类别">
                                {getFieldDecorator('companyType', {
                                    rules: [{ required: true, message: '请选择公司类别' }],
                                })(
                                    <Select placeholder="请选择公司类别">
                                        {companyTypes.map(type => (
                                            <Option key={type} value={type}>{type}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="行业所属">
                                {getFieldDecorator('industry', {
                                    rules: [{ required: true, message: '请选择行业所属' }],
                                })(
                                    <Select placeholder="请选择行业所属">
                                        {industries.map(industry => (
                                            <Option key={industry} value={industry}>{industry}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                    </Row>

                    {/* 关注产品（多选） */}
                    <Form.Item label="关注产品">
                        {getFieldDecorator('products', {
                            rules: [{ required: true, message: '请选择关注产品' }],
                        })(
                            <Select mode="multiple" placeholder="请选择关注产品">
                                {products.map(product => (
                                    <Option key={product} value={product}>{product}</Option>
                                ))}
                            </Select>
                        )}
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

// 使用Form.create()高阶组件包装UserInfoModalClass
const UserInfoModal = Form.create()(UserInfoModalClass);

export default UserInfoModal;
